import { BirthdaySetupFormType } from './BirthdaySetupFormType';

export const createInitialValues = (): BirthdaySetupFormType => ({
  day: 1,
  month: "01",
  nickname: "",
  phone: ""
});
